import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import useBrand from "./useBrand";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const { reset, handleSubmit, setErrors, setData, brandFields } = useBrand();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`brands/${id}/edit`).then(res => {
      reset(res.data.brand);
    });
  }, []);

  const editBrand = data => {
    const formData = new FormData();

    Object.entries(data).forEach(([property, value]) => {
      formData.append(`${property}`, value || '');
    });

    formData.append("_method", "PATCH");

    axios.post('brands/' + data.id, formData)
      .then(function (res) {
        if (res.status == 200) {
          swal('Brand has been updated successfully!', {
            icon: "success",
          });
          navigate("/brands");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit brand">
      <form className="form w-100 row" onSubmit={handleSubmit(editBrand)}>
        {brandFields}
        <SubmitButton
          title="Update"
          classes="w-auto d-inline-block"
        />
      </form>
    </Card>
  );
}